export default "__VITE_ASSET__CLzxVymF__"